import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * One item tag as the customer sees it: the label in the customer's language
 * and the two colours the store picked for the tag.
 */
export interface ItemTagDisplay {
  id?: number;
  label: string;
  backgroundColour: string;
  fontColour: string;
}

/**
 * The row of item tags shown directly below an item name (catalog tiles,
 * catalog list, item details, Offer items). Display only: tags react to
 * nothing, keep the order they are given in (the catalog sequence) and wrap
 * onto further lines instead of being cut. Colours come from each tag, never
 * from the store theme. Renders nothing when there are no tags.
 */
@Component({
  selector: 'app-item-tag-row',
  templateUrl: './item-tag-row.component.html',
  styleUrls: ['./item-tag-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemTagRowComponent {
  @Input() tags: ItemTagDisplay[] | null | undefined;

  /** `lg` is the slightly larger variant used on the item details page. */
  @Input() size: 'sm' | 'lg' = 'sm';

  trackByTag(index: number, tag: ItemTagDisplay): number | string {
    return tag.id ?? tag.label;
  }
}
